import React from 'react';
import {AI_ICON_PATH, AI_MATCH_TITLE} from '../../configs/aiMatch';
import {getRankedStarKind, RANKED_STAR_ICON_PATHS, RANKED_STAR_KINDS} from '../../utils/matches/rankedStarIcon';

// Подсказки звезды рейтингового лобби. У обычной — только alt, как и раньше;
// серая и синяя — админские (см. getRankedStarKind)
const RANKED_STAR_TITLES = {
  [RANKED_STAR_KINDS.DEFAULT]: null,
  [RANKED_STAR_KINDS.BOTS_ONLY]: 'Рейтинговое лобби ботов (видно только админам)',
  [RANKED_STAR_KINDS.MULTIPLAYER]: 'Рейтинговое лобби нескольких живых игроков (видно только админам)',
};

/**
 * Значки типа лобби перед его названием в списке (и на телефоне, и на
 * десктопе): метка ИИ у промо-матча (он рейтинговый, но вместо звездочки —
 * она), звезда рейтинга (у админа — цвет по живым игрокам), замок приватного
 * лобби — только админу: остальным приватное выглядит обычным начатым матчем
 *
 * @param {Object} props
 * @param {Object} props.lobby - дескриптор лобби из списка
 * @param {boolean} props.isViewerAdmin - админ или суперадмин (цвет звезды)
 * @param {boolean} props.isAdmin - админ (замок приватного лобби)
 */
const LobbyListTypeIcons = ({lobby, isViewerAdmin, isAdmin}) => {
  const renderRankedStar = () => {
    const starKind = getRankedStarKind({
      isViewerAdmin,
      isBotsOnlyMatch: lobby.isBotsOnlyMatch,
      // Число живых игроков сервер присылает только админу
      realPlayerCount: lobby.realPlayerCount ?? null,
    });
    const title = RANKED_STAR_TITLES[starKind];
    return (
      <img
        className="lobby-item-rating-icon"
        src={RANKED_STAR_ICON_PATHS[starKind]}
        alt={title || 'Рейтинговое лобби'}
        title={title || undefined}
      />
    );
  };

  return (
    <>
      {lobby.isAiMatch ? (
        <img
          className="lobby-item-rating-icon lobby-item-ai-icon"
          src={AI_ICON_PATH}
          alt={AI_MATCH_TITLE}
          title={AI_MATCH_TITLE}
        />
      ) : lobby.isRanked && renderRankedStar()}
      {lobby.isPrivate && isAdmin && (
        <img
          className="lobby-item-private-icon"
          src="/img/icons/lock_grey.png"
          alt="Приватное лобби (видно только админам)"
          title="Приватное лобби (видно только админам)"
        />
      )}
    </>
  );
};

export default LobbyListTypeIcons;
